var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { getGeometryStyle } from '../../helpers/styles';
var StyledListWidgetItem = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
});
var ListWidgetItem = function (props) {
    return React.createElement(StyledListWidgetItem, __assign({}, props));
};
export default ListWidgetItem;
var templateObject_1;
//# sourceMappingURL=index.js.map